import script from "./VolumeIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./VolumeIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__